import { render, staticRenderFns } from "./ComplaintSendSummary.vue?vue&type=template&id=cf6e6ed4&"
import script from "./ComplaintSendSummary.vue?vue&type=script&lang=js&"
export * from "./ComplaintSendSummary.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintSendSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports